const prefix='wiki-chat-comment-drafts-v1:';
const memory=new Map();
export function draftKey(composer){
  return JSON.stringify([composer.type,composer.parentId||null,composer.anchor||null]);
}
export function readDrafts(scope,termId){
  const key=prefix+scope+':'+termId;
  if(memory.has(key))return memory.get(key);
  try{const data=JSON.parse(localStorage.getItem(key)||'[]');const valid=Array.isArray(data)?data.filter(d=>typeof d.text==='string'&&d.composer&&['new','reply','edit-comment'].includes(d.composer.type)):[];memory.set(key,valid);return valid;}catch{return [];}
}
export function writeDraft(scope,termId,composer,text){
  const key=prefix+scope+':'+termId,id=draftKey(composer);
  const entries=readDrafts(scope,termId).filter(d=>draftKey(d.composer)!==id);
  if(text.trim())entries.unshift({composer,text});
  memory.set(key,entries);
  try{if(entries.length)localStorage.setItem(key,JSON.stringify(entries));else localStorage.removeItem(key);return true;}catch{return false;}
}
export function clearDemoDrafts(){
  for(const key of [...memory.keys()])if(key.startsWith(prefix+'demo:'))memory.delete(key);
  try{for(const key of Object.keys(localStorage))if(key.startsWith(prefix+'demo:'))localStorage.removeItem(key);}catch{}
}
